<template>
  <div>
    <el-card shadow="always" class="card">
      <div class="m-b-10">To set up Two Factor Authentication please follow below steps</div>
      <div class="m-b-5">
        Download Google Authenticator or Microsoft Authenticator App using below links
      </div>
      <div class="flexed-column m-b-10 gap-5">
        <div class="auth-item">
        <a :href="googleIosHref" target="_blank" rel="noopener noreferrer">Download Google Authenticator for iOS</a>
         <qrcode-vue :value="googleIosHref" size="40" level="H" />
       </div>
        <div class="auth-item">
         <a :href="googleAndroidHref" target="_blank" rel="noopener noreferrer">Download Google Authenticator for Android</a>
        <qrcode-vue :value="googleAndroidHref" size="40" level="H" />
       </div>
        <div class="auth-item">
         <a :href="microsoftIosHref" target="_blank" rel="noopener noreferrer">Download Microsoft Authenticator for iOS</a>
        <qrcode-vue :value="microsoftIosHref" size="40" level="H" />
       </div>
        <div class="auth-item">
         <a :href="microsoftAndroidHref" target="_blank" rel="noopener noreferrer"
          >Download Microsoft Authenticator for Android</a
        >
        <qrcode-vue :value="microsoftAndroidHref" size="40" level="H" />
        </div>
      </div>
      <div class="m-b-20">
        Once Installed, Open the app and tap on the (+) icon and scan the QR code below
      </div>
      <div class="qr-code m-b-20">
        <qrcode-vue :value="routeStore.mfaState?.qr_code_url" size="150" level="H" />
      </div>
      <div v-if="setupCode" class="setup-code m-b-20">
        <div class="setup-code__label">
          Can't scan it? Tap "Enter key manually" in the app and use this setup code instead.
        </div>
        <div class="setup-code__row">
          <code class="setup-code__value">{{ setupCodeDisplay }}</code>
          <el-button size="small" @click="copySetupCode()">Copy</el-button>
        </div>
      </div>
      <div class="flexed m-b-20" name="verifyForm" role="form" novalidate>
        <el-input
          v-model="token"
          name="token"
          type="text"
          id="token"
          class="form-control"
          @keypress="tokenOnKeypress($event)"
          placeholder="Enter your code here"
          required
          autofocus
        ></el-input>

        <el-button :loading="loading" type="primary" style="margin-left: 5px" @click="verify()"
          >Verify</el-button
        >
      </div>
    </el-card>
    <!-- <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      width="30%">
      <span>You have successfully setup Two factor Authentication for your account. Please login again.</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">OK</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import LoginService from '@/views/login/login.service'
import QrcodeVue from 'qrcode.vue'
import { RouteStore } from "@/store/routeStore.js";

export default {
  name: 'qrCodeScreen',
  components: {
    QrcodeVue
  },
  beforeMount() {
    if (!this.routeStore.mfaState?.bearerToken) this.routeStore.hkRouterPush({ name: 'different-login' })
  },
  data() {
    return {
      loading: false,
      token: null,
      activeTab: 'googleAuth',
      dialogVisible: false,
      routeStore: RouteStore()
    }
  },
  computed: {
    setupCode() {
      const qrCodeUrl = this.routeStore.mfaState?.qr_code_url
      if (!qrCodeUrl) return ''

      // the secret the authenticator needs is only ever delivered inside the otpauth
      // URL we render as a QR code, so manual entry has to read it back out of there
      const secretMatch = /[?&]secret=([^&]+)/i.exec(qrCodeUrl)

      return secretMatch ? decodeURIComponent(secretMatch[1]) : ''
    },
    setupCodeDisplay() {
      // grouped in fours so it can be read off the screen and typed without losing place
      return this.setupCode.replace(/.{4}(?=.)/g, '$& ')
    },
    microsoftAndroidHref() {
      return 'https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=en_IN&gl=US'
    },
    googleAndroidHref() {
      return 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_IN&gl=US'
    },
    microsoftIosHref() {
      return 'https://apps.apple.com/us/app/microsoft-authenticator/id983156458'
    },
    googleIosHref() {
      return 'https://apps.apple.com/us/app/google-authenticator/id388497605'
    }
  },
  methods: {
    async copySetupCode() {
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(this.setupCode)
        } else {
          this.copyViaTextarea(this.setupCode)
        }
        this.$message.success('Setup code copied')
      } catch {
        this.$message.error('Could not copy the setup code. Please type it in manually.')
      }
    },
    copyViaTextarea(text) {
      // navigator.clipboard is missing on the older embedded browsers this screen is
      // still opened in, so keep the deprecated path as a fallback
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.setAttribute('readonly', '')
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()

      const copied = document.execCommand('copy')
      document.body.removeChild(textarea)

      if (!copied) throw new Error('execCommand copy failed')
    },
    tokenOnKeypress(event) {
      if (event.keyCode === 13 || event.code == 'Enter') this.verify()
    },
    verify() {
      if (this.token) {
        let errorMsg
        var token = this.token || ''
        token = token.replace(/ /g, '') // remove spaces
        this.loading = true
        let payload = { data: token }
        LoginService.enrollTfaConfirm(
          this.routeStore.mfaState?.bearerToken,
          this.routeStore.mfaState?.hkInfo,
          payload
        )
          .then(() => {
            this.$alert(
              'You have successfully setup Two factor Authentication for your account. Please login again.',
              {
                confirmButtonText: 'OK',
                showClose: false,
                callback: () => {
                  if (
                    window.location.hostname !== 'localhost' &&
                    window.hkConfigEnvs.VUE_APP_LOGOUT_URL
                  ) {
                    const mfaUsername = this.routeStore.mfaState?.username
                    this.routeStore.mfaState = null
                    window.location.href = `${window.hkConfigEnvs.VUE_APP_LOGOUT_URL}&username=${mfaUsername}&state=HK_HOME`
                  } else {
                    this.routeStore.mfaState = null
                    this.routeStore.hkRouterPush({ name: 'different-login' })
                  }
                }
              }
            )
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                errorMsg = 'Invalid token'
                break
              case 401:
                errorMsg = 'Unauthorized'
                break
              case 403:
                errorMsg = 'Invalid username or password'
                break
              case 404:
                errorMsg = 'Resource not found'
                break
              case 500:
                errorMsg = 'Server error'
                break
              case 503:
                errorMsg = 'Server error'
                break
              case 423:
                errorMsg = 'Account Locked'
                break
              case 424:
                errorMsg = 'Account Inactive'
                break
              default:
                errorMsg = 'Login failed'
                break
            }
            if (errorMsg) this.$notify.error({ title: 'Error', message: errorMsg })
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  max-width: 430px;
  margin: 60px auto 0 auto;
  a {
    font-size: 15px;
  }
  .qr-code {
    width: 100%;
    text-align: center;
  }
}
.setup-code {
  text-align: center;
  &__label {
    font-size: 13px;
    margin-bottom: 8px;
  }
  &__row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  &__value {
    font-family: monospace;
    font-size: 15px;
    letter-spacing: 1px;
    word-break: break-all;
    user-select: all;
  }
}
.auth-item{
  display:flex;
  flex-direction:row;
  gap:10px;
  justify-content: space-between;
  margin-bottom: 15px;
  align-items:center;
}
</style>
